import { kSourceApiLrr, kSourceApiLrrV3 } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getAuth } from 'firebase/auth'

type GetSourceLrrVersionedResponse = {
  data: string
}

export type LrrVersionedInputs = {
  s3Path: string
  dataVersion: string
}

// Define a service using a base URL and expected endpoints
export const getSourceApi = createApi({
  reducerPath: 'getSourceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: kPaxtonAppApiRESTBaseUrl(),
    prepareHeaders: async (headers) => {
      // Add the auth token
      const token = await getAuth().currentUser?.getIdToken()
      if (token) {
        headers.set(`Authorization`, `Bearer ${token}`)
      } else {
        throw new Error("Could not retrieve user's authentication token.")
      }

      // Add the Content Type
      headers.set('Content-type', 'application/json; charset=UTF-8')

      return headers
    },
  }),

  endpoints: (builder) => ({
    getSourceLrr: builder.query<string, string>({
      query: (referenceId) => ({
        url: `${kSourceApiLrr}/${referenceId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 3600, // 1 hour - this does not need to be refetched often if the inputs do not change
    }),
    getSourceLrrVersioned: builder.query<GetSourceLrrVersionedResponse, LrrVersionedInputs>({
      query: (args) => {
        // v3 API is backwards compatible for html retrieval all data-versions <= 4
        const apiUrl = `${kSourceApiLrrV3}/${args.s3Path}`

        return {
          url: apiUrl,
          method: 'GET',
          params: args.dataVersion ? { data_version: args.dataVersion } : undefined,
        }
      },
      keepUnusedDataFor: 3600, // 1 hour - this does not need to be refetched often if the inputs do not change
    }),
  }),
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetSourceLrrQuery, useGetSourceLrrVersionedQuery } = getSourceApi
